<template>
  <div class="report-list-wrap">
    <template-search-read-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :initialSearchFilter="initialSearchFilter"
                          :selected="selected" 
                          :heightOffset="310"
                          @select="setSelected"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail"
                          @toReport="toReport"                                                   
                          >
      <ui-button :color="'pink'"
                 @click="openInsertModal">
        <i class="xi-plus"></i> 콘텐츠 추가
      </ui-button>
    </template-search-read-list>

    <template-detail v-if="apiParam"
                     :infoApi="infoApi"
                     :apiParam="apiParam"
                     @close="setSelected">
      <template #default="{ data }">
        <ui-button v-if="canEditContent(data)"
                   :color="'yellow'"
                   @click="openEditModal(data)">
          <i class="xi-pen"></i> 수정
        </ui-button>
      </template>
    </template-detail>

    <geo-content-insert-modal :show="showInsertModal"
                              :mode="insertModalMode"
                              :report="editReport"
                              @close="closeInsertModal"
                              @saved="handleInsertSaved"
                              @deleted="handleInsertSaved" />
  </div>
</template>

<script>

import { SOLOMON_URL, alertError } from '@/utils/tools'
import TemplateSearchReadList from '@/components/_template/SearchReadList.vue'
import TemplateDetail from '@/components/_template/Detail'
import UiButton from '@/components/_ui/UiButton'
import GeoContentInsertModal from '@/components/mine/geo/GeoContentInsertModal.vue'

import { EventBus } from '@/utils/event-bus'
import {getGeoAiReportInfo, getGeoAiReportList} from '@/api/mine'
import { STORAGE_ITEM } from '@/utils/constants'

export default {
  name: 'GeoAiReportList',
  components: {
    TemplateSearchReadList,
    TemplateDetail,
    UiButton,
    GeoContentInsertModal
  },
  created () {
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.userId) {
        this.initialSearchFilter = {}
        this.initialSearchFilter.userId = searchData.userId
        this.initialSearchFilter.userIdExact = true
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  methods: {
    reloadList () {
      this.reload++
    },
    closeActivePanel () {
      this.apiParam = null
      this.closeInsertModal()
    },
    openInsertModal () {
      this.closeActivePanel()
      this.insertModalMode = 'create'
      this.editReport = null
      this.showInsertModal = true
    },
    openEditModal (data) {
      this.closeActivePanel()
      this.insertModalMode = 'edit'
      this.editReport = data
      this.showInsertModal = true
    },
    closeInsertModal () {
      this.showInsertModal = false
    },
    getReportId (data) {
      return data ? (data._id || data.id || '') : ''
    },
    isSameContentModalOpen (data) {
      return this.showInsertModal &&
        this.insertModalMode === 'edit' &&
        this.getReportId(this.editReport) === this.getReportId(data)
    },
    isSameDetailOpen (data) {
      return this.apiParam && this.apiParam.aid === this.getReportId(data)
    },
    handleInsertSaved () {
      this.closeInsertModal()
      this.reloadList()
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    setSelected (row) {
      this.selected = row
    },  
    async showDetail (data) {
      if (this.isSameContentModalOpen(data) || this.isSameDetailOpen(data)) {
        this.closeActivePanel()
        this.selected = null
        return
      }
      this.closeActivePanel()
      if (this.canEditContent(data)) {
        EventBus.$emit('onLoading', true)
        try {
          const response = await this.infoApi({ aid: data._id })
          this.openEditModal(response.result.info)
        } catch (error) {
          alertError('상세 데이터를 불러오지 못 했습니다.', error)
        } finally {
          EventBus.$emit('onLoading', false)
        }
        return
      }
      this.$nextTick(() => {
        this.apiParam = { aid: data._id }
      })
    },
    toReport (data) {
      this.closeActivePanel()
      window.open(`${SOLOMON_URL}/schemaTag/${data._id}`)
    },
    canEditContent (data) {
      return data && ['cxTrends', 'whitePaper'].includes(data.type)
    }
  },
  data () {
    return {
      reload: 0,
      selected: null,      
      apiParam: null,
      showInsertModal: false,
      insertModalMode: 'create',
      editReport: null,

      listApi: getGeoAiReportList,
      infoApi: getGeoAiReportInfo,      
      buttonOption: [
        {
          action: 'toReport',
          columnText: '리포트',
          buttonText: '<i class="xi-document"></i>',
          if: ['state', '!=', 'error']
        },
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',
      searchFilter: {},
      initialSearchFilter: null
    }
  }
}
</script>

<style lang="scss" scoped>
.report-list-wrap {
}
</style>
